export default __webpack_public_path__ + "static/ASLA_Aptos_2-99acd9862b4ab21a46a2fe7dfedf509b.png";